/** A semana de funcionamento entre o backend e a tela.
 *
 * O `WorkingHours` do banco guarda uma linha por faixa aberta, e o editor
 * precisa das sete linhas da semana — inclusive a do domingo fechado, que
 * no banco simplesmente não existe. Estas duas funções fazem a tradução
 * nos dois sentidos.
 *
 * Moram aqui, e não junto do componente, porque `<WeekHours>` é o único
 * arquivo que o Fast Refresh precisa ver exportando apenas componentes.
 */

/** Início e fim, em "HH:MM" — a forma que o backend lê e devolve. */
export type Faixa = [string, string];

export interface DiaHorario {
  /** 0 = segunda, a convenção de ``WorkingHours.weekday`` no backend. */
  weekday: number;
  aberto: boolean;
  /** Preservadas mesmo com o dia fechado: quem desmarca a quarta por
   *  engano volta a marcar e encontra as faixas que tinha, não 09:00–18:00. */
  ranges: Faixa[];
}

/** O que um dia recém-aberto recebe, quando não há nada salvo. */
export const ABERTURA: Faixa = ["09:00", "18:00"];

/** Monta as sete linhas a partir do que veio do backend.
 *
 * Dia ausente na resposta é dia fechado — é assim que `WorkingHours`
 * representa: a loja não tem linha nenhuma para o domingo.
 */
export function semanaDeDias(dias: { weekday: number; ranges: Faixa[] }[]): DiaHorario[] {
  const salvos = new Map(dias.map((d) => [d.weekday, d.ranges]));
  return Array.from({ length: 7 }, (_, i) => {
    const ranges = salvos.get(i);
    return {
      weekday: i,
      aberto: !!ranges?.length,
      ranges: ranges?.length ? ranges : [ABERTURA],
    };
  });
}

/** A semana na forma que `PUT /working-hours/` espera. */
export function diasAbertos(semana: DiaHorario[]) {
  return semana.filter((d) => d.aberto).map(({ weekday, ranges }) => ({ weekday, ranges }));
}
